import styled from 'styled-components';
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1kki2nc-0"
})(["background-size:cover;height:100%;transition:background-image 0.1s ease-in;width:100%;"]);
export default Container;